module.exports = __webpack_public_path__ + "img/fslf_fishingcoins.f6bdacc.png";